var map = {
	"./template.bet575": 1749,
	"./template.bet575.tsx": 1749,
	"./template.bet777": 1750,
	"./template.bet777.tsx": 1750,
	"./template.betprofessor": 1751,
	"./template.betprofessor.tsx": 1751,
	"./template.betroyale": 1752,
	"./template.betroyale.tsx": 1752,
	"./template.betstride": 1753,
	"./template.betstride.tsx": 1753,
	"./template.buffalobet": 1754,
	"./template.buffalobet.tsx": 1754,
	"./template.chromabet": 1755,
	"./template.chromabet.tsx": 1755,
	"./template.default": 717,
	"./template.default.tsx": 717,
	"./template.epicodds": 1756,
	"./template.epicodds.tsx": 1756,
	"./template.fiestabet": 1757,
	"./template.fiestabet.tsx": 1757,
	"./template.forsport": 1758,
	"./template.forsport.tsx": 1758,
	"./template.gigabet": 1759,
	"./template.gigabet.tsx": 1759,
	"./template.goldenbet888": 1760,
	"./template.goldenbet888.tsx": 1760,
	"./template.goldenrush": 1761,
	"./template.goldenrush.tsx": 1761,
	"./template.hyperbet": 1762,
	"./template.hyperbet.tsx": 1762,
	"./template.juicybet": 1763,
	"./template.juicybet.tsx": 1763,
	"./template.junglebet": 1764,
	"./template.junglebet.tsx": 1764,
	"./template.magnumbet": 1765,
	"./template.magnumbet.tsx": 1765,
	"./template.oldgill": 1766,
	"./template.oldgill.tsx": 1766,
	"./template.puntcity": 1767,
	"./template.puntcity.tsx": 1767,
	"./template.puntgenie": 1768,
	"./template.puntgenie.tsx": 1768,
	"./template.pyramidbet": 1769,
	"./template.pyramidbet.tsx": 1769,
	"./template.questbet": 1770,
	"./template.questbet.tsx": 1770,
	"./template.slambet": 1771,
	"./template.slambet.tsx": 1771,
	"./template.sterlingparker": 1772,
	"./template.sterlingparker.tsx": 1772,
	"./template.templebet": 1773,
	"./template.templebet.tsx": 1773,
	"./template.titanbet": 1774,
	"./template.titanbet.tsx": 1774,
	"./template.ts": 992,
	"./template.vikingbet": 1775,
	"./template.vikingbet.tsx": 1775,
	"./template.volcanobet": 1776,
	"./template.volcanobet.tsx": 1776,
	"./template.wellbet": 1777,
	"./template.wellbet.tsx": 1777
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2480;